import { getDefaultWidthOverlay } from '../utils'

export const EventDesignSettings = {
  'event-design-width': {
    phone: [100],
    'phone-landscape': [100],
    tablet: [100],
    'tablet-landscape': [100],
    desktop: [50],
    tv: [50],
    overflowSetting: getDefaultWidthOverlay,
  },
}
